module.exports = __webpack_public_path__ + "static/media/marcacion_manual.5164d534.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/WorkBar/marcacion_manual.svg
// module id = 1870
// module chunks = 0